import React, { useEffect, useState } from "react";
import { useHistory, withRouter } from "react-router-dom";

import SparesInventory from './SparesInventory';
import VehicleInventory from './VehicleInventory';
import DenominationInventory from "./DenominationInventory";


const Reports = (props) => {

    const { type } = props
    const [sparesInventory, setSparesInventory] = useState(false);
    const [vehicleInventory, setVehicleInventory] = useState(false);
    const [denominationInventory, setDenominationInventory] = useState(false);
    useEffect(() => {
      if (type === "spares") {
        setSparesInventory(true);
        setVehicleInventory(false);
        setDenominationInventory(false);
      }
      else if (type === "vehicle"){
        setSparesInventory(false);
        setVehicleInventory(true);
        setDenominationInventory(false);
      } else if (type === "denomination") {
        setSparesInventory(false);
        setVehicleInventory(false);
        setDenominationInventory(true);
      }
    }, [type])

    return (
       <div>
          {sparesInventory && <SparesInventory />}
          {vehicleInventory && <VehicleInventory />}
          {denominationInventory && <DenominationInventory />}
       </div> 
    )
}

export default withRouter(Reports);